export function getEventPropsForOOB(props: Record<string, any>) {
  const eventProps = props || {};

  return {
    location: 'outOfBudget',
    ...eventProps,
  };
}
